import { ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [
        {
          text: [
            "3xs-v4",
            "2xs-v4",
            "xs-v4",
            "s-v4",
            "m-v4",
            "l-v4",
            "xl-v4",
            "2xl-v4",
            "3xl-v4",
          ],
        },
      ],
      leading: [
        { leading: ["xs-v4", "s-v4", "m-v4", "l-v4", "xl-v4", "2xl-v4"] },
      ],
      tracking: [{ tracking: ["s-v4", "m-v4", "l-v4"] }],
      "font-weight": [
        {
          font: [
            "light-v4",
            "normal-v4",
            "medium-v4",
            "semibold-v4",
            "bold-v4",
          ],
        },
      ],
      "font-family": [{ font: ["sans-v4", "mono-v4"] }],
      // Register every custom boxShadow name from tailwind.config.js so
      // shadow utilities conflict-merge with each other and with the stock
      // scale (shadow-sm etc.) instead of both being emitted.
      shadow: [
        {
          shadow: [
            "bas-sm",
            "bas-md",
            "bas-lg",
            "bas-dif",
            "bas-scr",
            "out-sm",
            "out-md",
            "out-lg",
            "out-dif",
            "out-scr",
            "action-outline",
            "elevation-3",
            "elevation-4",
            "elevation-5",
            "elevation-6",
            "elevation-7",
            "elevation-8",
            "dropdown",
            "phone-outline",
          ],
        },
      ],
      ease: [{ ease: ["bezier"] }],
    },
  },
});

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
